import store from '../../../store';
export default function checkIfCanSeeManageQuestions() {
  let scopes = store.getters.userScopes;
  return scopes.includes('manage_questions');
}
